import { api } from '@api'
import { AddNoteType, Ticket } from '@types'

interface GetNoteResponse {
  tickets: Ticket[]
}

export const addNote = async ({ id, note }: AddNoteType) => {
  const response = await api.post<GetNoteResponse>(`/tickets/${id}/notes`, { note })

  return response.data
}
